import axiosInstance from './apis';
import { BACKEND_API_URL } from "../environment";
import { userSignout } from '../apiservice/setting';

export const login = async (credentials) => {
  const response = await axiosInstance.post(`${BACKEND_API_URL}/signin`, credentials);

  // 🚨 Backend returned frontend HTML instead of JSON
  if (typeof response.data === "string" && response.data.includes("<!doctype")) {
    throw new Error("Invalid backend response (received HTML). Check BACKEND_API_URL.");
  }
  console.log(response, "response");

  // 🚨 Must have token + userInfo
  if (!response.data?.token || !response.data?.userInfo) {
    throw new Error(`${response.data.message}`);
    // throw new Error("Login failed: missing token or user info.");
  }

  if (response.data.error) {
    throw new Error(response.data.message || "Login failed.");
  }

  return response.data;
};


export const logout = async () => {
  try {
    const res = await userSignout({});
    return res.data;
  } catch (err) {
    console.error("Logout API error:", err);
    throw err;
  }
};

export const forgotPassword = async (email) => {
  const payload = { email };

  const res = await axiosInstance.post(`${BACKEND_API_URL}/forgotPassword`, payload);

  if (typeof res.data === "string" && res.data.includes("<!doctype")) {
    throw new Error("Invalid backend response (received HTML). Check BACKEND_API_URL.");
  }

  return res.data;
};